module.exports = __webpack_public_path__ + "static/media/Head4.759e14b8.svg";